import { Box, Skeleton, styled } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import useScreenWidth from '../../hooks/useScreenWidth'
import HiddenDesktop from '../../styles/HiddenDesktop'
import HiddenMobile from '../../styles/HiddenMobile'
import CardsSkeleton from './CardsSkeleton'

const NavBarContainer = styled('div')(() => ({
  height: 50,
  minHeight: 50,
  maxHeight: 50,
  display: 'flex',
  left: 0,
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  alignItems: 'center',
  padding: '0px 24px',
  backgroundColor: '#FAFAFA',
  position: 'fixed',
  top: 0,
  zIndex: 1200,
  width: '100%'
}))

const FilterContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: '0% 5% 0% 5%'
  },
  [theme.breakpoints.up('md')]: {
    padding: '0% 15% 0% 15%'
  },
  marginTop: 15,
  display: 'flex',
  boxSizing: 'border-box',
  justifyContent: 'space-between',
  height: 50
}))

const ContainerBtnMenuMobile = styled('div')(() => ({
  paddingTop: 8,
  paddingBottom: 10,
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center'
}))

function WebsiteSkeleton() {
  const isMobile = useScreenWidth(960)

  return (
    <Box sx={{ maxWidth: '1920px', margin: '0 auto' }}>
      {/* Navbar */}
      <NavBarContainer>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton animation="wave" width={59} height={26} variant="rectangular" style={{ marginRight: 32 }} />
          <HiddenMobile display="flex">
            <Skeleton animation="wave" width={87} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={79} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={63} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={80} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={80} height={27} variant="text" style={{ marginRight: 24 }} />
          </HiddenMobile>
          <HiddenDesktop>
            <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          </HiddenDesktop>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HiddenMobile display="flex" alignItems="center">
            <Skeleton animation="wave" width={208} height={32} variant="rectangular" sx={{ borderRadius: 8 }} />
            <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          </HiddenMobile>
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18, marginRight: 8 }} />
        </Box>
      </NavBarContainer>
      {/* Header */}
      <HiddenMobile>
        <Box>
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{ marginLeft: 25, height: 150, width: '100%', boxShadow: '23px -23px 43px #FFFFFF, 28px 28px 50px rgba(13, 39, 80, 0.16)' }}
          />
        </Box>
        <Box>
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              borderRadius: '0px 0px 0px 15px',
              marginTop: 5,
              marginLeft: 25,
              height: 50,
              width: '100%',
              boxShadow: '23px -23px 43px #FFFFFF, 28px 28px 50px rgba(13, 39, 80, 0.16)'
            }}
          />
        </Box>
      </HiddenMobile>
      <HiddenDesktop>
        <Box display="flex" alignItems="center" gap="5px">
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{ height: 60, width: '100%', boxShadow: '23px -23px 43px #FFFFFF, 28px 28px 50px rgba(13, 39, 80, 0.16)' }}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{ height: 60, width: '100%', boxShadow: '23px -23px 43px #FFFFFF, 28px 28px 50px rgba(13, 39, 80, 0.16)' }}
          />
        </Box>
      </HiddenDesktop>
      {/* Filters */}
      <HiddenMobile>
        <FilterContainer>
          <Box>
            <Skeleton animation="wave" width={220} height={35} variant="rectangular" style={{ borderRadius: 10 }} />
          </Box>
          <Box display="flex" alignItems="center" gap="5px">
            <Skeleton width={100} height={25} variant="rectangular" animation="wave" />
            <Skeleton width={100} height={25} variant="rectangular" animation="wave" />
            <Skeleton width={100} height={25} variant="rectangular" animation="wave" />
            <Skeleton width={100} height={25} variant="rectangular" animation="wave" />
          </Box>
        </FilterContainer>
      </HiddenMobile>
      <HiddenDesktop>
        <FilterContainer>
          <Box display="flex" alignItems="center" gap="5px">
            <Skeleton animation="wave" width={50} height={35} variant="rectangular" style={{ borderRadius: 10 }} />
          </Box>
          <Box display="flex" alignItems="center" gap="5px">
            <Skeleton width={70} height={25} variant="rectangular" animation="wave" />
            <Skeleton width={70} height={25} variant="rectangular" animation="wave" />
          </Box>
        </FilterContainer>
      </HiddenDesktop>
      {/* Menu mobile */}
      <HiddenDesktop>
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            top: 'auto',
            bottom: 0,
            padding: 8,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            zIndex: 1200
          }}
        >
          <Box sx={{ boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)', borderRadius: 16, backgroundColor: '#FAFAFA', display: 'flex' }}>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={65} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={60} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={46} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={68} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={48} height={20} variant="text" />
            </ContainerBtnMenuMobile>
          </Box>
        </Box>
      </HiddenDesktop>
      <Grid container spacing={isMobile ? 5 : 4} sx={{ width: '100%', margin: 0 }}>
        <Grid xs={12} style={isMobile ? { paddingTop: 10, paddingBottom: 2 } : { paddingLeft: '15%', paddingRight: '15%' }}>
          <Grid container spacing={2} style={{ paddingBottom: 10 }}>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={6} md={4} lg={3}>
              <CardsSkeleton />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box display="flex" flexDirection="column" alignItems="center" mt={3}>
        <Skeleton animation="wave" width={80} height={35} variant="rectangular" style={{ borderRadius: 10 }} />
      </Box>
    </Box>
  )
}

export default WebsiteSkeleton
